<template>
  <ls-table-layout>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="$refs.dataCreateModal.show(Object.assign({}),defaultDictType)" type="primary" v-hasPermi="['system:dict:add']">新增</a-button>
      <a-button @click="handleDeleteBatch(selectedRowKeys)" :disabled="selectedRowKeys.length === 0" v-hasPermi="['system:dict:remove']">删除</a-button>
      <a-button @click="handleExport()" v-hasPermi="['system:dict:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <a-table
          ref="table"
          :columns="columns"
          :loading="tableLoading"
          :data-source="dataList"
          :row-selection="rowSelection"
          row-key="dictCode"
          :pagination="false"
        >
          <!-- 更多选择 -->
          <span slot="action" slot-scope="text, record">
            <a @click="$refs.dataCreateModal.show(record,defaultDictType)" v-hasPermi="['system:dict:edit']">编辑</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">
                更多 <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;" @click="handleDelete(record)" v-hasPermi="['system:dict:remove']">删除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
          <!-- 插槽指向状态 -->
          <span slot="status" slot-scope="text, record">
            {{ statusFormat(record) }}
          </span>
          <!-- 插槽指向状态 -->
          <span slot="dictType" slot-scope="text, record">
            <router-link :to="'/dict/type/data/' + record.dictId" class="link-type">
              <span>{{ record.dictType }}</span>
            </router-link>
          </span>
        </a-table>
        <!-- 底部分页按钮 -->
        <a-pagination
          class="ant-table-pagination"
          v-model="pagination.current"
          :page-size-options="pagination.pageSizeOptions"
          :total="pagination.total"
          size="small"
          show-quick-jumper
          show-size-changer
          :page-size="pagination.pageSize"
          @showSizeChange="onShowSizeChange"
          @change="currentPageChange"
          :show-total="total => `共 ${total} 条数据`"
        >
          <!-- <template slot="buildOptionText" slot-scope="props">
              <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
              <span v-if="props.value === '50'">全部</span>
            </template> -->
        </a-pagination>

        <!-- 创建/编辑字典,单独封装了组件 -->
        <data-create-form
          ref="dataCreateModal"
          @handle-success="handleOk"
        />

      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { delData, listData } from '@/api/system/dict/data'
import { getType, listType } from '@/api/system/dict/type'
import DataCreateForm from './components/dataCreateForm'
export default {
  name: 'Data',
  components: {
    DataCreateForm
  },
  data () {
    return {
      // 默认字典类型
      defaultDictType: '',
      // 字典表格数据
      dataList: [],
      // 状态数据字典
      statusOptions: [],
      // 类型数据字典
      typeOptions: [],
      tableLoading: false,
      // 查询参数
      queryParams: {
        dictName: undefined,
        dictType: undefined,
        status: undefined
      },
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', ...this.$store.state.setting.pageSizeOptions],
        total: 0
      },
      // 表格字段
      columns: [
        {
          title: '字典编码',
          dataIndex: 'dictCode',
          align: 'center'
        },
        {
          title: '项目编码',
          dataIndex: 'dictLabel',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '项目值',
          dataIndex: 'dictValue',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '字典排序',
          dataIndex: 'dictSort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          ellipsis: true,
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          width: 140,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      }
    }
  },
  created () {
    const dictId = this.$route.params && this.$route.params.dictId
    this.getTypeData(dictId)
    // this.getList()
    this.getTypeList()
    this.getDicts('sys_normal_disable').then(response => {
      this.statusOptions = response.data
    })
  },
  methods: {
    /** pageSize 变化的回调 */
    onShowSizeChange (current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    },
    /** 页码改变的回调 */
    currentPageChange (current, pageSize) {
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getList()
    },
    /** 查询字典类型详细 */
    getTypeData (dictId) {
      getType(dictId).then(response => {
        this.queryParams.dictType = response.data.dictType
        this.defaultDictType = response.data.dictType
        this.getList()
      })
    },
    /** 查询字典类型列表 */
    getTypeList () {
      listType().then(response => {
        this.typeOptions = response.rows
      })
    },
    /** 查询字典数据列表 */
    getList () {
      this.tableLoading = true;
      const { current: pageNum, pageSize } = this.pagination;
      listData({ ...this.queryParams, pageNum, pageSize }).then(response => {
        this.dataList = response.rows
        this.pagination.total = response.total;
        this.tableLoading = false
      })
    },
    // 数据状态字典翻译
    statusFormat (row, column) {
      return this.selectDictLabel(this.statusOptions, row.status)
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('system/dict/data/export', {
        ...this.queryParams
      }, `data_${new Date().getTime()}.xlsx`)
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const dictCode = row.dictCode
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 字典编号为${dictCode}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delData(dictCode).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    /** 批量删除按钮操作 */
    handleDeleteBatch (ids) {
      const dictCodes = ids
      const self = this
      this.$confirm({
        title: '警告',
        content: `真的要删除 字典项编号为${dictCodes}的数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delData(dictCodes).then(response => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.getList()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 新增/修改框事件
    handleOk () {
      this.getList()
    }
  }
}
</script>
